export default {
  main: {
    title: 'Xác minh Phiên bản',
    language: 'Tiếng Việt',
    intro:
      'Xác minh phiên bản được thực hiện bằng cách so khớp các giá trị băm MD5 hoặc SHA256 giữa các phiên bản. Vui lòng đảm bảo tải ví TokenPocket thông qua các kênh chính thức để tránh bị lừa đảo. Để biết hướng dẫn về cách lấy giá trị băm MD5 hoặc SHA256 của một phiên bản, vui lòng ',
    tutorial: 'xem hướng dẫn >',
    system: 'Hệ điều hành',
    android: 'Android',
    ios: 'iOS',
    version: 'Phiên bản',
    allVersion: 'Tất cả',
    appChannel: 'Kênh ứng dụng',
    developer: 'nhà phát triển',
    allChannel: 'Tất cả',
    md5: 'MD5',
    sha256: 'SHA256',
    log: 'Nhật ký Phiên bản',
    check: 'Chi tiết',
    versionLog: 'Nhật ký Phiên bản',
    confirm: 'Xác nhận',
    aboutIOS: 'Về Phiên bản iOS',
    IOSDesc:
      'Đối với phiên bản iOS, chúng tôi chỉ cung cấp ứng dụng của mình trên App Store. Chỉ có ứng dụng tải xuống thông qua App Store mới có thể được cài đặt đúng cách. Do đó, khi sử dụng thiết bị Apple, hãy đảm bảo xác thực App Store là kênh tải xuống duy nhất.',
    IOSDesc_2:
      'Nhà phát triển của phiên bản tải xuống từ App Store trước ngày 8 tháng 10 năm 2022 là TOKENPOCKET FOUNDATION LTD, đó là một phiên bản sớm được phát triển bởi TokenPocket. Đó là một ví tiền điện tử hợp pháp có thể sử dụng bình thường, nhưng dịch vụ cập nhật sẽ tạm ngừng trong một thời gian ngắn.',
    aboutAndroid: 'Về Phiên bản Android',
    androidDesc: 'Các kênh tải TokenPocket cho Android hiện tại bao gồm: trang web chính thức, Google Play Store, Samsung App Store, Huawei AppGallery, OPPO App Store và Vivo App Store. Tại một số cửa hàng ứng dụng, không thể lấy được gói cài đặt APK trong quá trình tải xuống, do đó không thể thực hiện kiểm tra MD5 hoặc SHA256. Do đó, khi tải xuống, hãy chắc chắn kiểm tra thông tin của nhà phát triển, tham khảo phía dưới!',
    IOSAppName: 'Tên ứng dụng:',
    TPWallet: 'TP Wallet',
    AppIcon: 'Biểu tượng ứng dụng:',
    AppDeveloper: 'Nhà phát triển:',
    downloadLink: 'Liên kết Tải xuống:',
    copied: 'Đã sao chép!',
    versionVerification: 'Version Verification',
  },
  follow: {
    title: 'Theo chúng tôi',
    desc1: 'Nhân viên TokenPocket sẽ không gửi tin nhắn riêng tư cho bạn!',
    desc2:
      'Thận trọng! Bạn đang tham gia cộng đồng TokenPocket, có thể có ai đó mạo danh chúng tôi để gửi tin nhắn riêng tư cho bạn! Xin lưu ý rằng bất kỳ ai gửi tin nhắn riêng tư đều có thể là kẻ lừa đảo! Chúng tôi sẽ không bao giờ liên hệ với bạn trước!',
    desc3: 'Đã hiểu, nhập',
  },
  COMMON: {
    LAYOUT: {
      features: 'Tính năng',
      products: 'Sản phẩm',
      buyCryptoFooter: 'buyCrypto',
      mobileWallet: 'Ví Điện Thoại',
      mobileWalletDesc: 'Ví di động Crypto & DeFi trên blockchain.',
      hardwareWallet: 'Ví Cứng',
      hardwareWalletDesc: 'Nhận KeyPal của bạn để bảo vệ tài sản của bạn.',
      extensionWallet: 'Ví Mở Rộng',
      extensionWalletDesc: 'Một ví tốt hơn trên máy tính của bạn.',
      desktop: 'Desktop Wallet',
      fiveDegrees: '5Degrees',
      versionVerification: 'Xác Minh Phiên Bản',
      versionVerificationDesc: 'Xác minh ví của bạn.',
      approvalDetector: 'Phát Hiện Phê Duyệt',
      approvalDetectorDesc: 'Xem và hủy phê duyệt các token đã phê duyệt của bạn.',
      tokenSecurity: 'An Ninh Token',
      tokenSecurityDesc: 'Xác minh token có an toàn bằng địa chỉ hợp đồng của nó.',
      keyGenerator: 'Tạo Khóa',
      keyGeneratorDesc: 'Tạo ngẫu nhiên khóa công khai và khóa riêng cho các mạng khác nhau.',
      tokenProfile: 'Hồ Sơ Token',
      tokenProfileDesc: 'Tìm hiểu tất cả thông tin về token.',
      tokenClaim: 'Yêu Cầu Token',
      tokenClaimDesc: 'Nhận airdrop của bạn.',
      easyInscription: 'Khắc Chữ Dễ Dàng',
      easyInscriptionDesc: 'Công cụ khắc an toàn.',
      nostrAssetsBatchSender: 'NostrAssets BatchSender',
      nostrAssetsBatchSenderDesc: 'Công cụ gửi hàng loạt cho NostrAssets.',
      BATCH_SENDER: 'BatchSender',
      BATCH_SENDER_DESC: 'Gửi token cho nhiều người nhận cùng một lúc.',
  
      trade: 'Công cụ',
      swap: 'Hoán đổi',
      swapDesc: 'Giao dịch với giá tốt nhất.',
      bridge: 'Cầu Nối',
      bridgeDesc: 'Chuyển tài sản từ chuỗi này sang chuỗi khác một cách mượt mà.',
      buyCrypto: 'Mua',
      buyCryptoDesc: 'Mua tiền điện tử bằng thẻ tín dụng của bạn.',
      market: 'Thị Trường',
      marketDesc: 'Thông tin chi tiết theo thời gian thực để khám phá các token hot.',
  
      information: 'Thông tin',
      blockchainGuide: 'Hướng dẫn về Blockchain',
      tronWallet: 'Hướng dẫn về TRON',
      iostWallet: 'Hướng dẫn về IOST',
      tpMan: 'TP Man',
  
      developers: 'Nhà Phát Triển',
      github: 'Github (TP-Lab)',
      devCenter: 'Trung tâm phát triển',
      developersDesc: 'Tài liệu phát triển TokenPocket.',
      subToken: 'Nộp Token',
      subTokenDesc: 'Gửi token của bạn.',
      subDApp: 'Nộp DApp',
      subDAppDesc: 'Gửi DApp của bạn và hiển thị nó sau khi kiểm duyệt.',
      subNFT: 'Nộp NFT',
      subNFTDesc: 'Gửi NFT và nghệ thuật của bạn.',
      subChain: 'Nộp Chuỗi',
      subChainDesc: 'Gửi blockchain của bạn.',
      bugBounty: 'Bug Bounty',
  
      tools: 'Công cụ',
  
      build: 'Xây dựng',
  
      learn: 'Học',
  
      explorer: 'Trình khám phá',
  
      company: 'Công ty',
      about: 'Giới thiệu',
      careers: 'Nghề nghiệp',
      pressKit: 'Bộ công cụ thương hiệu',
      swagShop: 'Swag Shop',
  
      support: 'Hỗ trợ',
      helpCenter: 'Trung tâm Trợ giúp',
      helpCenterDesc: 'Nguồn tài nguyên của bạn để có câu trả lời và hỗ trợ.',
      contactUs: 'Liên hệ Chúng Tôi',
      contactUsDesc: 'Chia sẻ đề xuất của bạn và hỏi bất kỳ câu hỏi nào.',
      forum: 'Diễn Đàn',
      forumDesc: 'Thưởng thức các cuộc trò chuyện với các thành viên cộng đồng.',
  
      legal: 'Hợp pháp',
      privacyPolicy: 'Chính sách bảo mật',
      terms: 'Điều khoản Sử dụng',
  
      toHome: 'Trang chủ',
      defiWallet: 'Ví DeFi',
      ETHWallet: 'Ví Ethereum',
      ethWallet: 'Ví ETH',

      dappStore: 'Cửa hàng DApp'
    }
  }
};
